/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function treatment() {
        document.documentElement.classList.add('w33');

        if (['/', '/search', '/search/'].includes(location.pathname)) {
            document.documentElement.classList.add('no-top-margin');
        }

        Mojito.utils.waitForElement('.header-sticky-wrapper', function (anchor) {
            var announcementBar = document.createElement('div');
            announcementBar.className = 'new-announcement';
            announcementBar.innerHTML = `
                <div class="inner">
                    <a href="/collections/sale-items">
                        <span class="emoji">🎉</span>
                        <span class="announcement-text" style="font-weight:700">
                            Save up to 50% off on clothing, toys, feeding & more! 
                        </span>
                    </a>
                </div>
            `;

            anchor.insertAdjacentElement('beforebegin', announcementBar);

            window.setTimeout(function () {
                announcementBar.classList.add('animate');
                window.setTimeout(function () {
                    announcementBar.classList.add('animate-background');
                }, 710);
            });
        });
    }

    function trigger() {
        if (location.pathname.includes('/checkouts/') || location.pathname.includes('/orders/')) {
            return;
        }

        Mojito.utils.domReady(treatment);
    }

    trigger();
})();
